import { Column, Entity, PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn, ManyToOne, JoinColumn } from "typeorm";
import { TrimsMapping } from "./trims-configuration.entity";
@Entity('trim_items_mapping')
export class TrimItemsMapping {

    @PrimaryGeneratedColumn("increment", { name: 'trim_item_id' })
    trimItemId: number;

    @Column("int", {
        nullable: false,
        name: "sub_category_id"
    })
    subcategoryId: number;
    @Column("int", {
        nullable: false,
        name: "item_id"
    })
    itemId: number;
    @Column("int", {
        nullable: false,
        name: "trim_id"
    })
    trimId: number;
    @Column("varchar", {
        nullable: false,
        name: "against_to"
    })
    AgainstTo: string;
    @Column("int", {
        nullable: false,
        name: "number_of_trims"
    })
    numberOfTrims: number;
    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @ManyToOne(type => TrimsMapping, trim => trim.trimItemsInfo, { nullable: false })
    @JoinColumn({ name: "trim_id" })
    trimInfo: TrimsMapping;
}
